import React from "react";
import { Table } from "react-bootstrap";
import { isValidArray } from "../../../helper";
import NoDataFound from "../../../component/NoDataFound";
import { LoaderTemplate as DefaultLoader } from "./loaderTemplate";
function TableTemplate({
  isBestPracticesTable = false,
  isRoleTable,
  isGroupTable,
  isUsersTable,
  isLoading = false,
  LoaderTemplate = DefaultLoader,
  headersOptions = [],
  bodyOptions = [],
  headersTemplate,
  tableOptions = {},
  classes = "",
  bodyTemplate,
  checkboxLoader,
  isNotificationTable
}) {
  const getTableClassName = () =>
    [
      isBestPracticesTable
        ? "best-practices-container-cms"
        : "admin-table-container-cms",

      isUsersTable === true && "pmg-table",

      isNotificationTable === true && "notification-table",

      classes
    ]
      .filter(Boolean)
      .join(" ");
  return (
    <Table
      responsive
      striped
      hover
      size="sm"
      {...tableOptions}
      className={getTableClassName()}
    >
      <thead className="no-sort-icon users-table-header">
        <tr className="pmg-table">
          {headersOptions.map((value, index) => {
            return headersTemplate ? headersTemplate(value, index) : null;
          })}
        </tr>
      </thead>
      <tbody className="users-table-body">
        {checkboxLoader == true ? (
          checkboxLoader == true ? (
            <tr align="center" className="table-loader">
              <td colspan={headersOptions.length}>
                <LoaderTemplate />
              </td>
            </tr>
          ) : (
            <tr align="center">
              <td colspan={headersOptions.length}>Loading...</td>
            </tr>
          )
        ) : isValidArray(bodyOptions) ? (
          bodyOptions.map((value, index) => (
            <tr key={index}>
              {bodyTemplate ? bodyTemplate(value, index) : null}
            </tr>
          ))
        ) : (
          <>
            {!isLoading ? (
              <tr align="center">
                <td colspan={headersOptions.length}>
                  <NoDataFound />
                </td>
              </tr>
            ) : (
              <></>
            )}
          </>
        )}
      </tbody>
    </Table>
  );
}

export { TableTemplate };
